import React, { useEffect, useState } from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { useChat } from '../../common/ChatContext';
import ChatDrawer from './ChatDrawer';

// Chat is a brand-new feature — a soft pulsing glow draws the eye to it
// until someone actually opens it once, then it never shows again for them.
const NEW_FEATURE_STORAGE_KEY = 'chatFeatureSeen';

const pulseKeyframes = {
  '0%, 100%': { boxShadow: '0 0 0 0 rgba(19, 114, 116, 0.5)' },
  '50%': { boxShadow: '0 0 0 6px rgba(19, 114, 116, 0)' },
};

const ChatBell = ({ isLoggedIn }) => {
  const { unreadTotal, drawerOpen, openDrawer, closeDrawer } = useChat();
  const [highlightNew, setHighlightNew] = useState(false);

  useEffect(() => {
    try {
      setHighlightNew(localStorage.getItem(NEW_FEATURE_STORAGE_KEY) !== '1');
    } catch {
      setHighlightNew(false);
    }
  }, []);

  const handleOpen = () => {
    openDrawer();
    if (!highlightNew) return;
    setHighlightNew(false);
    try {
      localStorage.setItem(NEW_FEATURE_STORAGE_KEY, '1');
    } catch {
      // Private browsing / storage disabled — the glow just won't persist
      // as dismissed, so it may reappear next visit. Harmless either way.
    }
  };

  if (!isLoggedIn) return null;

  return (
    <>
      <Tooltip title={highlightNew ? 'Messages — new!' : 'Messages'}>
        <IconButton
          onClick={handleOpen}
          size="small"
          sx={{
            color: 'inherit',
            opacity: 0.8,
            '&:hover': { opacity: 1 },
            ...(highlightNew && {
              animation: 'chat-bell-pulse 1.6s ease-in-out infinite',
              '@keyframes chat-bell-pulse': pulseKeyframes,
            }),
          }}
        >
          <Badge badgeContent={unreadTotal} color="error" max={99} overlap="circular">
            <ChatBubbleOutlineRoundedIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>
      <ChatDrawer open={drawerOpen} onClose={closeDrawer} />
    </>
  );
};

export default ChatBell;
